/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import { getBaseServiceConfig } from '../../../../_base';
import { ConsoleService } from '../../Console.service';
import { ConsoleServiceConfiguration } from '../../Console.service.config';
import { LOCAL_STORAGE_KEY_DXP_SERVICE_TOKENS } from '../../Console.service.constant';

/**
 * Get the Console Service.
 * @export
 * @returns {ConsoleService} The Console Service.
 */
export const getConsoleService = (): ConsoleService => {
  // DXP Console service uses a different path structure to other DXP services.
  const baseServiceConfig = getBaseServiceConfig(`${process.env.DXP_CONSOLE_SESSION_API_URL}`);

  const { updateConsoleService, updateTokens } = useConsoleServiceStore.getState();
  const { consoleService }: { consoleService: ConsoleService | null } = useConsoleServiceStore.getState();

  if (!consoleService) {
    const consoleServiceConfig: ConsoleServiceConfiguration = baseServiceConfig;
    const newConsoleService = new ConsoleService(consoleServiceConfig);
    updateConsoleService(newConsoleService);

    const tokens = localStorage.getItem(LOCAL_STORAGE_KEY_DXP_SERVICE_TOKENS);

    if (tokens) {
      updateTokens(JSON.parse(tokens));
    }

    return newConsoleService;
  }

  return consoleService;
};
